
export class UnidadeDTO{

    id!: number;
    nome!: string;
    nomeCompleto!: string;
    endereco!: string;
    codigo!: string;
}